<template>
  <a :style="style" @mouseenter="setInitialValues" @mousemove="updatePositions">
    <slot />
  </a>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";

const posX = ref(0);
const posY = ref(0);
const width = ref(0);

const setInitialValues = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  width.value = target.offsetWidth;
  updatePositions(event);
};

const updatePositions = (event: MouseEvent) => {
  posX.value = event.offsetX;
  posY.value = event.offsetY;
};

const style = computed(() => {
  return {
    "--x": `${posX.value}px`,
    "--y": `${posY.value}px`,
    "--w": `${width.value}px`,
  };
});
</script>
